import {Environment} from './environment.interface';

export const environment: Environment = {
  production: true,
  tokenTimeoutDuration: 1000 * 60 * 60 * 24 * 30,
  apiConfig: {
    baseUrl: 'https://api.trackstream.app',
    services: {
      assets: {
        baseUrl: 'https://assets.api.trackstream.app',
        suffix: '/api'
      },
      iam: {
        baseUrl: 'https://iam.api.trackstream.app',
        suffix: '/api'
      },
    }
  }
};
